const breakpoints = ["1em", "30em", "45em", "64em", "80em", "86em", "100em"];

const [xs, sm, md, xm, lg, ml, xl] = breakpoints;
breakpoints.xs = xs;
breakpoints.sm = sm;
breakpoints.md = md;
breakpoints.xm = xm;
breakpoints.lg = lg;
breakpoints.ml = ml;
breakpoints.xl = xl;

const fonts = {};

const colorSets = [
  {
    name: "primary",
    colors: [
      { name: 100, hex: "#2e3192" },        
      { name: 500, hex: "#0e0f56" },
    ],
  },
  {
    name: "secondary",
    colors: [
      { name: 100, hex: "#ff6e3d" },      
      { name: 500, hex: "#f15f22" },     
    ],
  },
  {
    name: "accent",
    colors: [
      { name: 100, hex: "#364DFF" },            
      { name: 500, hex: "#2E59D9" },          
    ],
  },
  {
    name: "grey",
    colors: [   
      { name: 50, hex: "#F4F4F4" },   
      { name: 100, hex: "#B3B3B3" },
      { name: 200, hex: "#e3e5e5" },      
      { name: 300, hex: "#808080" },      
      { name: 500, hex: "#4D4D4D" },
    ],
  }, 
  {
    name: "dark",
    colors: [
      { name: 100, hex: "#141414" },
      { name: 500, hex: "#0e0e0e" },     
    ]
  }, 
  {
    name: "success",
    colors: [      
      { name: 100, hex: "#1CC88A" },      
      { name: 500, hex: "#149466" },
    ],
  },
  {
    name: "info",
    colors: [
      { name: 100, hex: "#40DBF2" },
      { name: 500, hex: "#36B9CC" },
    ],
  },
  {
    name: "danger",
    colors: [
      { name: 100, hex: "#FF5E41" },
      { name: 500, hex: "#E74A3B" },
    ],
  },
  {
    name: "warning",
    colors: [
      { name: 100, hex: "#FFD540" },
      { name: 500, hex: "#F6C23E" },
    ],
  },  
];

export const colors = colorSets.reduce(
  (colorMap, { name, alias = name, colors: colorSet }) => {
    const color = {};
    const cm = colorMap;
    for (let colorIndex = 0; colorIndex < colorSet.length; colorIndex++) {
      const { name: colorName, hex } = colorSet[colorIndex];
      color[colorIndex] = hex;
      color[colorName] = hex;
    }
    cm[name] = color;
    cm[alias] = color;
    return cm;
  },
  {    
    white: "#FFFFFF",
    "white.0": "#FFFFFF",
    black: "#000000",
    "black.0": "#000000",
  }
);

const radii = {
  small: "0.125rem",
  normal: "0.1875rem",
  large: "0.375rem",
  full: "10rem",
  square: 0,
};

const zIndices = {
  modal: 2000,
  tooltip: 5000,
  toast: 7000,
};

const shadows = [
  { name: "none", shadow: undefined },
  { name: "sm", shadow: "0 .075rem .15rem rgba(0,0,0,.15)" },
  { name: "xl", shadow: "0 0 1rem rgba(0,0,0,.15)" },
].reduce((shadowSet, { name, shadow }, index) => {
  const s = shadowSet;
  s[name] = shadow;
  s[index] = shadow;
  return s;
});

export const theme = {  
  breakpoints,
  radii,
  colors,
  zIndices,
  shadows,
  fonts,
};
